// extracted by mini-css-extract-plugin
export default {"card":"Card_card__oso-+","title":"Card_title__6Ww0d","body":"Card_body__Kr6Rk"};